export default __webpack_public_path__ + "static/media/wesco-renewables.5a907de4.png";